module.exports = __webpack_public_path__ + "img/102.8ed84eb4.jpg";